import { ExerciseDetailsByDate } from '@demind-inc/core';
import { Dayjs } from 'dayjs';

export const getExerciseDetailsForDate = (
  exerciseDetails: ExerciseDetailsByDate[] | unknown,
  selectedDate: Dayjs
): ExerciseDetailsByDate | undefined => {
  if (!Array.isArray(exerciseDetails)) {
    return undefined;
  }

  const dateStr = selectedDate.format('YYYY-MM-DD');
  return exerciseDetails.find(({ date }) => date === dateStr);
};

export const getVisibleExerciseActivitiesForDate = (
  exerciseDetails: ExerciseDetailsByDate[] | unknown,
  selectedDate: Dayjs
) => {
  return (
    getExerciseDetailsForDate(exerciseDetails, selectedDate)?.details.filter((a) => !a.hide) ?? []
  );
};
